import { render, staticRenderFns } from "./DownloadCertificate.vue?vue&type=template&id=502f4eac&scoped=true"
import script from "./DownloadCertificate.vue?vue&type=script&lang=js"
export * from "./DownloadCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502f4eac",
  null
  
)

export default component.exports